import React from 'react';
import { AvFeedback, AvGroup, AvInput, AvField } from 'availity-reactstrap-validation';
import { Col, Label } from 'reactstrap';
import PropTypes from 'prop-types';

const InviteUserForm = ({ user }) => {
  const staff = user || {};

  return (
    <React.Fragment>
      <AvGroup row>
        <Label sm={2} for="email" className="text-right">Email</Label>
        <Col sm={10}>
          <AvInput type="email" className="form-control" name="email" placeholder="user@nightingale.com" defaultValue={staff.email} required />
          <AvFeedback color="danger">Please enter a valid email</AvFeedback>
        </Col>
      </AvGroup>

      <AvGroup row>
        <Label sm={2} for="role" className="text-right">Role</Label>
        <Col sm={10}>
          <AvField type="select" className="form-control" name="role" defaultValue="CNA" required>
            <option value="CNA">CNA</option>
            <option value="ADMIN">ADMIN</option>
          </AvField>
        </Col>
      </AvGroup>
    </React.Fragment>
  );
};

InviteUserForm.propTypes = {
  user: PropTypes.shape({
    email: PropTypes.string.isRequired,
    role: PropTypes.string.isRequired,
  }),
};

InviteUserForm.defaultProps = {
  user: null,
};

export default InviteUserForm;



// WEBPACK FOOTER //
// ./src/components/InviteUserForm.js